import { render, staticRenderFns } from "./richtext-block.vue?vue&type=template&id=6e95eb72&scoped=true&"
import script from "./richtext-block.vue?vue&type=script&lang=js&"
export * from "./richtext-block.vue?vue&type=script&lang=js&"
import style0 from "./richtext-block.vue?vue&type=style&index=0&id=6e95eb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e95eb72",
  null
  
)

export default component.exports